import Image from '@/components/Image';
import Link from '@/components/Link';
import Tooltip from '@/components/Tooltip';
import TrainerPageSection from './TrainerPageSection';

function TrainerCertificationBadge({ title, badge, uri }) {
  return (
    <Tooltip tooltip={title}>
      <Link href={uri}>
        <Image src={badge.sourceUrl} width={200} height={200} alt={title} />
      </Link>
    </Tooltip>
  );
}

export default function TrainerCertifications({ certifications }) {
  return (
    <TrainerPageSection title="Certificaciones obtenidas">
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6">
        {certifications.map(({ id, title, featuredImage, uri }) => (
          <div key={id} className="lg:col-span-2">
            <TrainerCertificationBadge
              title={title}
              badge={featuredImage.node}
              uri={uri}
            />
          </div>
        ))}
      </div>
    </TrainerPageSection>
  );
}
